module.exports = __webpack_public_path__ + "img/caja1.13ac91f9.gif";